import type { InterceptRuleSummary } from '@terra/shared-dto-chat-types';
import type { InterceptRule } from '../store/proxy-store';

export function mapInterceptRuleToSummary(
  rule: InterceptRule,
): InterceptRuleSummary {
  return {
    ruleId: rule.id,
    ruleName: rule.name,
    urlPattern: rule.urlPattern,
    methods: rule.methods,
    enabled: rule.enabled,
    ...(rule.description ? { description: rule.description } : {}),
  };
}

export function filterInterceptRulesForList({
  rules,
  nameFilter,
}: {
  rules: InterceptRule[];
  nameFilter?: string;
}): InterceptRule[] {
  const normalizedFilter = nameFilter?.trim().toLowerCase();
  if (!normalizedFilter) {
    return rules;
  }

  return rules.filter((rule) => {
    const haystack = [rule.name, rule.urlPattern, rule.description ?? '']
      .join(' ')
      .toLowerCase();
    return haystack.includes(normalizedFilter);
  });
}
